import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { formatApiError } from "@/api/client";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
    } catch (_) {
      setUser(null);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    try {
      const { data } = await client.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("boardroom_token", data.access_token);
      setUser({
        id: data.id, email: data.email, name: data.name, role: data.role,
        must_change_password: !!data.must_change_password,
        intro_acknowledged_at: data.intro_acknowledged_at || null,
      });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("boardroom_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout, refresh: bootstrap, refreshUser: bootstrap }}>{children}</AuthCtx.Provider>;
}
